export function getHash() {
  return Math.round(Math.random() * 10000000000000)
}

export function isNumber(number) {
  return isFinite(number)
}

export function toNumber(value) {
  return Number(value)
}

export function isOdd(number) {
  return number % 2 === 1
}
